module.exports = __webpack_public_path__ + "static/media/logo_flanders-state-of-the-art.05ebe5db.svg";